import React from "react";

/**
 * MD | CONSULTING wordmark.
 * The "MD" is inside a thin gold rule box; the "CONSULTING" is a light letter-spaced label.
 */
export default function Logo({ className = "", variant = "default", testId = "brand-logo" }) {
  const goldColor = variant === "dark" ? "#0d1b3e" : "#c9a84c";
  const textColor = variant === "dark" ? "#0d1b3e" : "#f5f2e9";
  return (
    <a
      href="#top"
      data-testid={testId}
      className={`inline-flex items-center gap-3 group select-none ${className}`}
      aria-label="MD Consulting — home"
    >
      <span
        className="font-display font-bold tracking-tight text-[1.15rem] leading-none px-2.5 py-1.5 border transition-colors duration-500"
        style={{ color: goldColor, borderColor: goldColor }}
      >
        MD
      </span>
      <span
        className="h-4 w-px"
        style={{ background: goldColor, opacity: 0.6 }}
        aria-hidden
      />
      <span
        className="font-sans-crisp uppercase text-[0.68rem] font-medium"
        style={{ color: textColor, letterSpacing: "0.32em" }}
      >
        Consulting
      </span>
    </a>
  );
}
